export enum DialogTypes {
  Trivia = 'TRIVIA',
  CorrectAnswer = 'CORRECT_ANSWER',
  IncorrectAnswer = 'INCORRECT_ANSWER',
}

export type Trivia = {
  id: string;
  question: string;
  fact: string;
  readMoreLink: string;
  correctAnswers: number | null;
  wrongAnswers: number | null;
  answers: {
    correctId: number;
    variants: { id: number; value: string }[];
  };
  type: string;
  category: string;
  difficulty: string;
};

export type ShellVisibility = {
  lastSeen: number;
  tabs: number;
  maxTabs: number;
  totalCount: number;
};

export type TriviaState = {
  dialogMode: DialogTypes;
  trivia: Trivia;
  visibility: ShellVisibility;
  answers: string[];
  disabled: boolean;
  showTrivia: boolean;
};
